import React, { useEffect, useRef, useState } from "react";
import BesRecentRequestSection from "./BesRecentRequestSection";
import BesRequestDetailsHeader from "./BesRequestDetailsHeader";
import BesRequestDetailsSection from "./BesRequestDetailsSection";
import { AEROMEGH_SERVICES, QUEUE_ORDER_STATUS, STATUS } from "../../appConstants";
import { getBesRequest, getBesRequests } from "../../apis/requests";
import Popup from "../../ReusableFunctions/Popup";
import Loading from "../../ReusableFunctions/Loader";
import { useLocation, useNavigate } from "react-router";
import { useSelector } from "react-redux";

export default function BesRequestsOverView() {
    const [requests, setRequests] = useState([]);
    // const { user } = useSelector((state) => state.user);
    const [isLoading, setIsLoading] = useState(false);
    const [recentRequestsLoading, setrecentRequestsLoading] = useState(false);
    const [previousRequestLoading, setPreviousRequestLoading] = useState(false);
    const { state } = useLocation();
    const navigate = useNavigate();
    const [selectedRequest, setselectedRequest] = useState(undefined);
    const [sprayingRequest, setSprayingRequest] = useState({}); // Move state here
    const [popupState, setPopupState] = useState({
        reschedule: false,
        cancel: false,
        hold: false,
        complete: false,
    });
    const [filters, setFilters] = useState(state?.filters || {});
    const [currentPageNumber, setCurrentPageNumber] = useState(filters.pageNumber);
    const [hasMore, setHasMore] = useState(true);
    const [initialLoad, setInitialLoad] = useState(true);
    const requestInvoiceRef = useRef();
    const [selectedStatus, setSelectedStatus] = useState(selectedRequest?.status);

    const getRequestsAPI = async (
        pageSize,
        pageNumber,
        statusType,
        filters,
        searchQuery,
        fromDate,
        toDate,
        pilotId,
        isOrderByServiceTime,
        userId
    ) => {
        try {
            setIsLoading(true);
            const data = await getBesRequests(
                userId,
                filters,
                pageSize,
                pageNumber,
                statusType,
                searchQuery,
                fromDate,
                toDate,
                pilotId,
                isOrderByServiceTime ? isOrderByServiceTime : false,
            );
            setRequests(data.requests.map(req => ({ ...req, page: pageNumber || 1 })));
            setselectedRequest(state?.request);
            setIsLoading(false);

            return data.requests;
        } catch (err) {
            console.log("errr:", err);
            setIsLoading(false);
            Loading.set(false);
            Popup.alert("Error", err, "ERROR");
        }
    };

    const getInitalData = async () => {
        try {
            let pageNumber = filters?.pageNumber || 1;

            let requestsData = await getRequestsAPI(
                15,
                filters?.pageNumber,
                filters?.statusType,
                {
                    locations: filters?.locations,
                    services: filters?.services,
                    statuses: filters?.statuses,
                    orderBy: filters?.orderBy,
                    orderType: filters?.orderType,
                },
                null,
                filters?.fromDate ? new Date(new Date(filters?.fromDate).setHours(0, 0, 0, 0)).toISOString() : undefined,
                filters?.toDate ? new Date(new Date(filters?.toDate).setHours(23, 59, 59, 999)).toISOString() : undefined,
                filters?.pilotId ? filters.pilotId : undefined,
                filters?.isOrderByServiceTime ? filters?.isOrderByServiceTime : undefined,
                filters.userId,
            );

            // on page refresh if there is no request in requests and page number is greater than 1 then, fetch requests of page - 1
            if ((!requestsData || requestsData.length === 0) && pageNumber > 1) {
                const prevPage = pageNumber - 1;
                setFilters((prev) => ({ ...prev, pageNumber: prevPage }));
                setCurrentPageNumber(prevPage);
                console.log("extra call");
                const prevRequests = await fetchPreviousRequests(prevPage);
                if (prevRequests && prevRequests.length > 0) {
                    setRequests(prevRequests.map(req => ({ ...req, page: prevPage })));
                    setselectedRequest(prevRequests[0]);
                } else {
                    setRequests([]);
                    setselectedRequest(null);
                }
            }

        } catch (error) {
            console.log("error", error);
        }
    };


    const fetchPreviousRequests = async (pageNumber) => {
        if (pageNumber < 1) return;
        try {
            setPreviousRequestLoading(true);
            const data = await getBesRequests(
                undefined,
                {
                    locations: filters?.locations,
                    services: filters?.services,
                    statuses: filters?.statuses,
                    orderBy: filters?.orderBy,
                    orderType: filters?.orderType,
                },
                15,
                pageNumber,
                filters?.statusType,
                null,
                filters?.fromDate ? new Date(new Date(filters?.fromDate).setHours(0, 0, 0, 0)).toISOString() : undefined,
                filters?.toDate ? new Date(new Date(filters?.toDate).setHours(23, 59, 59, 999)).toISOString() : undefined,
                undefined,
                false,
            );

            if (data.requests.length > 0) {
                setRequests((prevRequests) => [...data.requests.map(req => ({ ...req, page: pageNumber })), ...prevRequests]);
            }
            return data.requests;
        } catch (err) {
            Popup.alert("Error", err, "ERROR");
        } finally {
            setTimeout(() => setPreviousRequestLoading(false), 500);
        }
    }


    const fetchMoreRequests = async (pageNumber) => {
        if (!hasMore) return;
        setrecentRequestsLoading(true);
        try {
            const data = await getBesRequests(
                undefined,
                {
                    locations: filters?.locations,
                    services: filters?.services,
                    statuses: filters?.statuses,
                    orderBy: filters?.orderBy,
                    orderType: filters?.orderType,
                },
                15,
                pageNumber,
                filters?.statusType,
                null,
                filters?.fromDate ? new Date(new Date(filters?.fromDate).setHours(0, 0, 0, 0)).toISOString() : undefined,
                filters?.toDate ? new Date(new Date(filters?.toDate).setHours(23, 59, 59, 999)).toISOString() : undefined,
                undefined,
                false,
            );

            if (data.requests.length > 0) {
                setRequests((prevRequests) => [...prevRequests, ...data.requests.map((req => ({ ...req, page: pageNumber })))]);
                setFilters((prevFilters) => ({
                    ...prevFilters,
                    pageNumber: pageNumber
                }))
            } else {
                setHasMore(false);
            }
        } catch (err) {
            Popup.alert("Error", err, "ERROR");
        } finally {
            setrecentRequestsLoading(false);
        }
    };

    const getRequestDetails = async () => {
        if (!requests || requests.length === 0) {
            setselectedRequest(null);
            return;
        }
        if (!selectedRequest || !requests?.some(req => req.id === selectedRequest?.id)) {
            setselectedRequest(requests[0]);
            return; // stop here, details will load for new selection on next call
        }

        if (!selectedRequest?.id) return;
        setIsLoading(true);
        let requestData = await getBesRequest(
            {
                type: selectedRequest?.type || AEROMEGH_SERVICES.SPRAYING,
                id: selectedRequest?.id,
            },
            true,
            true,
            true,
            true
        );
        console.log(selectedRequest);
        setselectedRequest(() => ({ ...selectedRequest, ...requestData.request }));
        setselectedRequest((prev) => ({
            ...prev,
            //   type: prev.invoice.request_type,
        }));
        setIsLoading(false);
    };

    useEffect(() => {
        if (state?.request) {
            if (initialLoad) {
                getInitalData();
                setInitialLoad(false);
            }
        } else {
            navigate("/manageRequests");
        }
    }, [state?.request]);

    useEffect(() => {
        getRequestDetails();
    }, [selectedRequest?.id]);

    console.log("filters", filters)

    return (
        <div className="w-full px-10 py-8 bg-[#D9D9D9] h-[100%] font-manrope ">
            <div className="bg-[#FFFFFF] border border-[#D9D9D9] h-[500px] min-h-[100%] flex rounded-[15px] ">
                {!state?.hideRecentRequestSection &&
                    <div className="w-[23%]">
                        <BesRecentRequestSection
                            isLoading={recentRequestsLoading}
                            previousRequestLoading={previousRequestLoading}
                            filters={filters}
                            selectedRequest={selectedRequest}
                            requests={requests}
                            hasMore={hasMore}
                            fetchPreviousRequests={fetchPreviousRequests}
                            fetchMoreRequests={fetchMoreRequests}
                            handleRequestClick={(request) => {
                                if (request?.id === selectedRequest?.id) {
                                    return;
                                }
                                setselectedRequest(request);
                                setSelectedStatus(request?.status)
                            }}
                            currentPageNumber={currentPageNumber}
                        />
                    </div>
                }
                <div className={`${state?.hideRecentRequestSection ? 'w-[100%]' : 'w-[80%]'}  flex flex-col`}>
                    <BesRequestDetailsHeader
                        setPopupState={setPopupState}
                        request={selectedRequest}
                        sprayingRequest={sprayingRequest}
                        requestInvoiceRef={requestInvoiceRef}
                        selectedStatus={selectedStatus}
                        setSelectedStatus={setSelectedStatus}
                        onRequestUpdate={async (buttonType, updatedRequest, updatedStatus) => {
                            try {
                                setIsLoading(true);
                                // const originalPage = updatedRequest?.page || 1;
                                // let newRequests = await getRequestsAPI(15, originalPage, "Placed", undefined, undefined, filters.fromDate, filters.toDate, null, undefined, undefined);
                                // if(newRequests.length > 0) {
                                //     if (newRequests[0]?.id === selectedRequest?.id) {
                                //         return;
                                //     }
                                //     setselectedRequest(newRequests[0]);
                                // }
                                if (updatedStatus === "Accepted") {
                                    const updatedRequests = requests.filter((req) =>
                                        req.id !== updatedRequest.id
                                    );
                                    setRequests(updatedRequests);

                                    // if no requests on current page
                                    if (updatedRequests.length === 0) {
                                        const prevPage = (filters.pageNumber || 1) - 1;
                                        if (prevPage >= 1) {
                                            setFilters((prev) => ({ ...prev, pageNumber: prevPage }));
                                            setCurrentPageNumber(prevPage);
                                            const prevRequests = await fetchPreviousRequests(prevPage);
                                            if (prevRequests && prevRequests.length > 0) {
                                                setRequests(prevRequests.map(req => ({ ...req, page: prevPage })));
                                                setselectedRequest(prevRequests[0]);
                                            } else {
                                                setselectedRequest(null);
                                            }
                                        } else {
                                            setselectedRequest(null);
                                        }
                                    } else {
                                        setselectedRequest(updatedRequests[0]);
                                    }
                                } else {
                                    const updatedRequests = requests.map((req) =>
                                        req.id === updatedRequest.id
                                            ? { ...req, status: updatedStatus }
                                            : req
                                    );
                                    setRequests(updatedRequests);
                                    setselectedRequest(updatedRequest);
                                    setSelectedStatus(updatedStatus);
                                }

                                await getRequestDetails()
                                if (buttonType === "Accepted") {
                                    Popup.alert(
                                        "Request Accepted!",
                                        `Your request no. ${updatedRequest?.req_number} has been accepted ! `,
                                        "SUCCESS"
                                    );
                                }
                                if (buttonType === "Cancel") {
                                    Popup.alert(
                                        "Request Rejected!",
                                        `Your request no. ${updatedRequest?.req_number} has been rejected ! `,
                                        "SUCCESS"
                                    );
                                }
                            } catch (err) {
                                console.log("error", err);
                                Popup.alert("ERROR", err, "ERROR");
                            } finally {
                                setIsLoading(false);
                                Loading.set(false);
                            }
                        }}
                    />
                    <div className="w-full  max-h-full overflow-y-scroll h-full  flex">
                        <BesRequestDetailsSection
                            popupState={popupState}
                            ref={requestInvoiceRef}
                            sprayingRequest={sprayingRequest}
                            isLoading={isLoading}
                            setSprayingRequest={setSprayingRequest}
                            setPopupState={setPopupState}
                            request={selectedRequest}
                            requestInvoiceRef={requestInvoiceRef}
                            selectedStatus={selectedStatus}
                            requests={requests}
                            setSelectedStatus={setSelectedStatus}
                            onResetStatus={() => setSelectedStatus(selectedRequest?.status)}
                            onRequestUpdate={async (updatedRequest, updateType) => {
                                try {
                                    setIsLoading(true);
                                    const updatedRequests = requests.map((req) =>
                                        req.id === updatedRequest.id
                                            ? { ...req, status: updatedRequest?.status }
                                            : req
                                    );
                                    setRequests(updatedRequests);
                                    setSelectedStatus(updatedRequest?.status)
                                    await getRequestDetails();
                                    setPopupState((prevState) => ({
                                        ...prevState,
                                        reschedule: false,
                                    }));
                                    if (updateType === STATUS.RESCHEDULED) {
                                        Popup.alert(
                                            "Request Reschedule!",
                                            `Your request no. ${sprayingRequest?.req_number} has been Reschedule ! `,
                                            "SUCCESS"
                                        );
                                    } else if (updateType === STATUS.CANCELLED) {
                                        Popup.alert(
                                            "Request Cancelled!",
                                            `Your request no. ${sprayingRequest?.req_number} has been cancelled ! `,
                                            "SUCCESS"
                                        );
                                    } else if (updateType === STATUS.HOLD) {
                                        Popup.alert(
                                            "Request Hold!",
                                            `Your request no. ${sprayingRequest?.req_number} has been hold! `,
                                            "SUCCESS"
                                        );
                                    } else if (updateType === STATUS.COMPLETED) {
                                        Popup.alert(
                                            "Request Completed!",
                                            `Your request no. ${sprayingRequest?.req_number} has been completed! `,
                                            "SUCCESS"
                                        );
                                    }
                                    setIsLoading(false);
                                } catch (err) {
                                    setIsLoading(false);
                                    console.log("error", err);
                                    Popup.alert("ERROR", err, "ERROR");
                                }
                            }}
                        />

                    </div>
                </div>
            </div>
        </div>
    );
}
